export default {
    methods: {
        /**
         * Преобразование размера файла в байтах в читабельный вид
         *
         * @param bytes {number} - размер файла в байтах
         * @param measuresTrans {string} - строка с единицами измерения
         *  в иерархическом порядке, пример 'Б КБ МБ ГБ ТБ'
         * @returns {string}
         * @private
         */
        _humanFileSize(bytes, measuresTrans) {
            let i = 0,
                units = measuresTrans.split(' '),
                size;

            do {
                bytes = bytes / 1024;
                i++;
            } while (bytes > 1024);

            size = bytes.toFixed(1);

            return `${size} ${units[i]}`;
        },
    }
};
